export class storeUserMenus {
    static readonly type = '[storeUserMenus] storeUserMenus';

    constructor(public payload:any[]) {
    }
    
}